import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/file-pdf.vue
var o = {
	name: "DtIconFilePdf",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--file-pdf"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "File Pdf",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [
		r("path", {
			"fill-rule": "evenodd",
			"clip-rule": "evenodd",
			d: "M1.94.94A1.5 1.5 0 0 1 3 .5h4.25a.5.5 0 0 1 .354.146l2.75 2.75a.5.5 0 0 1 .146.354v.75a.5.5 0 0 1-1 0H7a.5.5 0 0 1-.5-.5V1.5H3a.5.5 0 0 0-.5.5v2.5a.5.5 0 0 1-1 0V2c0-.398.158-.78.44-1.06ZM7.5 1.956V3.5h1.543L7.5 1.957ZM2 9.5a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5.5.5 0 0 1 1 0A1.5 1.5 0 0 1 9 11.5H3A1.5 1.5 0 0 1 1.5 10a.5.5 0 0 1 .5-.5Z",
			fill: "currentColor"
		}, null, -1),
		r("path", {
			d: "M3.26 7.297h-.425v-.938h.425c.168 0 .299.04.392.12a.43.43 0 0 1 .142.346v.004c0 .15-.048.265-.142.347-.093.08-.224.12-.392.12Zm2.252.808h.423c.173 0 .32-.033.44-.1a.65.65 0 0 0 .274-.295c.063-.13.095-.289.095-.475V7.23a1.01 1.01 0 0 0-.097-.463.65.65 0 0 0-.277-.29.88.88 0 0 0-.435-.101h-.423v1.728Z",
			fill: "currentColor"
		}, null, -1),
		r("path", {
			"fill-rule": "evenodd",
			"clip-rule": "evenodd",
			d: "M1.852 5.241a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h8.277a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H1.852Zm.983 3.32v-.833h.569c.196 0 .368-.037.516-.111a.824.824 0 0 0 .343-.315.893.893 0 0 0 .124-.475v-.004a.89.89 0 0 0-.124-.474.824.824 0 0 0-.343-.314 1.116 1.116 0 0 0-.516-.114H2.25v2.64h.585Zm2.091 0V5.92h1.102c.278 0 .515.052.71.154.196.101.345.249.448.443.104.193.156.428.156.704v.003c0 .285-.052.526-.156.725a1.05 1.05 0 0 1-.446.455 1.502 1.502 0 0 1-.712.156H4.926Zm2.972-2.64v2.64h.586V7.52h1.139v-.436H8.484v-.708h1.247V5.92H7.898Z",
			fill: "currentColor"
		}, null, -1),
		r("path", {
			"fill-rule": "evenodd",
			"clip-rule": "evenodd",
			d: "M2.835 7.297h.425a.86.86 0 0 0 .144-.012.498.498 0 0 0 .279-.138.384.384 0 0 0 .084-.143L3.77 7a.548.548 0 0 0 .025-.171v-.006a.542.542 0 0 0-.026-.17l-.001-.005a.388.388 0 0 0-.086-.141l-.002-.003a.498.498 0 0 0-.275-.135.862.862 0 0 0-.144-.01h-.425v.938ZM2.25 8.56h.585v-.833h.569a1.131 1.131 0 0 0 .592-.154.807.807 0 0 0 .267-.272.893.893 0 0 0 .124-.473v-.006a.89.89 0 0 0-.124-.474.807.807 0 0 0-.265-.27l-.003-.002a1.116 1.116 0 0 0-.591-.156H2.25v2.64Zm-.398.68a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h8.277a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H1.852Zm7.77-2.156H8.485v-.708h1.247V5.92H7.898v2.64h.586V7.52h1.139v-.436Zm-2.811-.969a1.13 1.13 0 0 0-.194-.096 1.622 1.622 0 0 0-.589-.099H4.926v2.64h1.102c.228 0 .428-.035.6-.104a1.161 1.161 0 0 0 .18-.091 1.04 1.04 0 0 0 .37-.4v-.002l.008-.014c.103-.197.154-.435.155-.715v-.012a1.478 1.478 0 0 0-.165-.723 1.058 1.058 0 0 0-.365-.383Zm-.164.652a.664.664 0 0 0-.16-.21l-.002-.001a.648.648 0 0 0-.115-.08.826.826 0 0 0-.342-.097 1.184 1.184 0 0 0-.093-.003h-.423v1.728h.423c.032 0 .063-.001.093-.003a.834.834 0 0 0 .36-.104.647.647 0 0 0 .096-.07l.002-.001a.665.665 0 0 0 .177-.247v-.002c.054-.124.081-.272.081-.443v-.012a1.03 1.03 0 0 0-.097-.454Z",
			fill: "currentColor"
		}, null, -1)
	])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=file-pdf.js.map